import { MimaButton, MimaInput, MimaText, Modal } from '../../components';
import { Formik } from 'formik';

const EditFaqCategory = ({
    loading,
    validationSchema,
    onSubmit,
    closeModal,
    data,
}) => {
    return (
        <Modal closeModal={closeModal}>
            <Formik
                initialValues={{
                    name: data.name ? data.name : "",                  
                }}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
            >
                {({
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    values,
                    errors,
                    touched,
                }) => (
                    <>
                        <MimaText variant="subtitleBold" mb={4}>Edit Category</MimaText>
                        <MimaInput
                            labelTitle="Category Name"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.name}
                            touched={touched.name}
                        />

                        <MimaButton
                            title="Update"
                            loading={loading}
                            width={38}
                            mt={2}
                            buttonColor="var(--color-dark-4)"
                            onClick={handleSubmit}
                        />
                    </>
                )}

            </Formik>
        </Modal>
    )
}
export default EditFaqCategory;